import { useNavigate } from "react-router-dom";
import useAppState from "../../../context/AppContext";
import { APP_RETIREMENT_URLS } from "../../../const/AppConst";
import StickButtonsBloc from "../../common/StickButtonsBloc";
import { useForm } from "react-hook-form";
import InfoAttestationROTemplate, { InfoAttestationROFormData, validationSchemaInfoAttestationRO } from "../../../components/info-perso-template/InfoAttestationROTemplate";
import { yupResolver } from "@hookform/resolvers/yup";
import { formattedNir, getValueNoSpace } from "../../../utils/utils";
import { useEffect, useState } from "react";
import ConfirmModal from "../../../modals/common/ConfirmModal";
import GeneralDataProtectionBloc from "../../common/GeneralDataProtectionBloc";

const regimeWarningMsg = " Le régime indiqué ne correspond pas à votre déclaration initiale. Le tarif proposé peut différer lors de la validation de votre contrat."

export default function REInfoAttestationROBloc() {

  const navigate = useNavigate();
  const [warningMsg, setWarningMsg] = useState<string|null>(null)
  const [isShowModal, setIsShowModal] = useState(false);

  useEffect(()=>{
    if(warningMsg === regimeWarningMsg){
      setIsShowModal(true)
    }
  }, [warningMsg])
  
  const {
    state: { updatedProposition, socialSecurityDocuments, additionalData, proposition },
    dispatch
  } = useAppState();

  const {
    register,
    setValue, 
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm<InfoAttestationROFormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      attachmentOrganization: updatedProposition?.attachmentOrganization ? updatedProposition.attachmentOrganization.replace(/(\d{2})(\d{3})(\d{4})/, '$1 $2 $3').trim() : '',
      fileAttachId: socialSecurityDocuments.find(doc => doc.name === "Attestation de droits") ? socialSecurityDocuments.find(doc => doc.name === "Attestation de droits")!.id : null,
      alsaceMoselleRegime: !!updatedProposition?.alsaceMoselleRegime,
      nir: updatedProposition?.nir ? formattedNir(updatedProposition.nir) : '',
      nirKey: updatedProposition?.nirKey ? updatedProposition.nirKey : '',
      canBeModified: true,
      birthDate: updatedProposition?.birthDate ?? '',
      civilityCode: updatedProposition?.civilityCode ?? ''
    },
    resolver: yupResolver(validationSchemaInfoAttestationRO),
  });

  const checkRegime = async(data: InfoAttestationROFormData) => {
    if(data.alsaceMoselleRegime !== updatedProposition?.alsaceMoselleRegime) {
      setWarningMsg(regimeWarningMsg);
    } else {
      onNextAction(data)
    }
  }

  const onNextAction = async (data: InfoAttestationROFormData) => {
      let tempUpdatedPropo = updatedProposition;
      if(tempUpdatedPropo) {
        tempUpdatedPropo.attachmentOrganization = data.attachmentOrganization.replace(/ /g, '');
        tempUpdatedPropo.alsaceMoselleRegime = data.alsaceMoselleRegime;
        tempUpdatedPropo.nir = getValueNoSpace(data.nir);
        tempUpdatedPropo.nirKey = data.nirKey
      };
      if(socialSecurityDocuments.length < 1) {
        return;
      };

    const hasBeneficiaryStep = additionalData?.hasChild || additionalData?.hasPartner;
    
    const nextUrl = hasBeneficiaryStep 
                      ? APP_RETIREMENT_URLS.infoAttestationROBeneficiaryPage 
                      : proposition?.configuration?.requireIdentityDocument 
                          ? APP_RETIREMENT_URLS.infoIdentityDocPage 
                          : APP_RETIREMENT_URLS.infoRetirementDocPage;
   
    dispatch({type: 'NEXT_INFO_STEP', path: nextUrl, updatedProposition: tempUpdatedPropo});
    navigate({
        pathname: nextUrl
    });         
  }
  const onPreviousAction = async () => {
    const url = APP_RETIREMENT_URLS.infoBankPage
   
    dispatch({type: 'BACK_INFO_STEP', path: url});
    navigate({
        pathname: url
    });         
  }

  return (
    <form style={{width: '100%'}}>
        <div className='form-row page-content'>
          <InfoAttestationROTemplate 
            register={register} 
            errors={errors} 
            setValue={setValue} 
            canBeModified={true}  
            getValues={getValues}
            reset={reset}/>
           
        </div>
         {warningMsg !==null && 
          <ConfirmModal
            isOpen={isShowModal} 
            onConfirmAction={handleSubmit(onNextAction)} 
            onCloseModal={()=>{
            setIsShowModal(false)
              setWarningMsg(null)
            }}
            text={<p className="ta-center bleu fz-lg fw-bold">
            {warningMsg}
              </p>} />
        }
        <StickButtonsBloc 
            showPreviousButton={true} 
            disabledPreviousButton={false} 
            nextAction={handleSubmit(checkRegime)} 
            showNextButton={true} 
            previousAction={onPreviousAction}/>   
        <GeneralDataProtectionBloc/> 
    </form>
  )
}